import API from '../../components/api'
import { User } from './user'

export const getUsers = async (): Promise<User[]> => {
  return (await API.get<User[]>('/users')).data
}

type ActiveUserEntry = {
  email: string
  displayName: string
}

export const getActiveUsers = async () => {
  return (await API.get<ActiveUserEntry[]>('/users/active')).data
}

export const getForemen = async () => {
  return (await API.get<User[]>('/users/foremen')).data
}